import React, { FC } from 'react'
import EditClientContainer from 'containers/EditClient'

const EditClientPage: FC = () => <EditClientContainer />

export default EditClientPage
